import React, { useState, useMemo, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import './MapaCanchasPadel.css';

const COD_CANCHA_PADEL = 'CANCHA14P';

const MapaCanchasPadel = ({ show, onHide, obtenerPartidosEnCurso, canchasDisponibles, slotsMatriz }) => {
    const [horaTest, setHoraTest] = useState('');
    const [tick, setTick] = useState(0);
    const [vista, setVista] = useState('mapa');

    // Siempre arrancar en mapa al abrir
    React.useEffect(() => {
        if (show) setVista('mapa');
    }, [show]);

    useEffect(() => {
        const interval = setInterval(() => setTick(t => t + 1), 30000);
        return () => clearInterval(interval);
    }, []);

    const partidos = useMemo(() => {
        if (!obtenerPartidosEnCurso) return [];
        return obtenerPartidosEnCurso(horaTest || null);
    }, [obtenerPartidosEnCurso, horaTest, slotsMatriz, canchasDisponibles]);

    // Buscar partido en curso en la cancha de pádel
    const partido = useMemo(() => {
        return partidos.find(p => p.codCancha === COD_CANCHA_PADEL) || null;
    }, [partidos]);

    const enUso = !!partido;
    const jugadores = partido?.jugadores || [];
    const dobles = enUso && partido.tipoJuego && partido.tipoJuego.startsWith('DOBLES');

    const getMinutosRestantes = (horaFin) => {
        if (!horaFin) return null;
        const [hh, mm] = horaFin.split(':').map(Number);
        let ahora;
        if (horaTest) {
            const [ah, am] = horaTest.split(':').map(Number);
            ahora = ah * 60 + am;
        } else {
            const now = new Date();
            ahora = now.getHours() * 60 + now.getMinutes();
        }
        const fin = hh * 60 + mm;
        const diff = fin - ahora;
        return diff > 0 ? diff : 0;
    };

    const getNombreCorto = (jugador) => {
        return jugador?.shortName || jugador?.nombre || '';
    };

    const minutosRestantes = enUso ? getMinutosRestantes(partido.horaFin) : null;

    const renderLista = () => {
        const ahora = new Date();
        const horaActual = `${String(ahora.getHours()).padStart(2, '0')}:${String(ahora.getMinutes()).padStart(2, '0')}`;
        const fechaActual = ahora.toLocaleDateString('es-AR');

        // Filtrar solo partidos de pádel
        const partidosPadel = partidos.filter(p => p.codCancha === COD_CANCHA_PADEL);

        return (
            <div className="mapaPadelListaContainer">
                <div className="mb-3 text-center" style={{ marginTop: '25px' }}>
                    <small style={{ color: '#aaa' }}>
                        Fecha y hora actual: <strong style={{ color: '#ccc' }}>{fechaActual} {horaActual}</strong>
                    </small>
                </div>
                {partidosPadel.length === 0 ? (
                    <p style={{ color: '#aaa' }} className="text-center mb-0">
                        No hay partidos de pádel en curso en este momento
                    </p>
                ) : (
                    partidosPadel.map((p) => (
                        <div key={p.reservaId || p.codCancha} className="mapaPadelListaCard">
                            <div className="mb-2">
                                <strong style={{ color: '#1a6bb5' }}>{p.codCancha}</strong> - {p.cancha}
                            </div>
                            <div className="mb-2">
                                <small style={{ color: '#aaa' }}>Horario:</small> <strong>{p.horaInicio} - {p.horaFin}</strong>
                            </div>
                            <div>
                                <small style={{ color: '#aaa' }}>Jugadores:</small>
                                {p.jugadores.length > 0 ? (
                                    <ul className="mb-0 mt-1" style={{ paddingLeft: '20px' }}>
                                        {p.jugadores.map((jugador, idx) => (
                                            <li key={idx} style={{ fontSize: '0.9em' }}>
                                                {jugador.nombre}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <span style={{ color: '#888', marginLeft: '8px' }}>Sin jugadores registrados</span>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered dialogClassName="mapaPadelModal" style={{ zIndex: 10000 }} backdropClassName="mapaPadelBackdrop">
            <Modal.Body style={{ padding: 0, position: 'relative' }}>
                <button className="minimizarBtn" onClick={onHide} style={{ position: 'absolute', top: 5, right: 5, zIndex: 1, padding: '0.2rem 0.6rem', fontSize: '1rem' }}>X</button>

                {/* Selector de hora para testing */}
                <div className="mapaPadelHoraTest">
                    <label>Hora simulada:</label>
                    <input
                        type="time"
                        value={horaTest}
                        onChange={e => setHoraTest(e.target.value)}
                    />
                    {horaTest && <button onClick={() => setHoraTest('')}>Ahora</button>}
                    <button
                        className="mapaPadelVistaBtn"
                        onClick={() => setVista(vista === 'mapa' ? 'lista' : 'mapa')}
                    >
                        {vista === 'mapa' ? 'Lista' : 'Mapa'}
                    </button>
                </div>

                {vista === 'mapa' ? (
                    <div className="mapaPadelContainer">
                        {/* Cabina de tenis */}
                        <div className="mapaPadelCabina">
                            <div className="mapaPadelCabinaTecho" />
                            <div className="mapaPadelCabinaCuerpo">
                                <div className="mapaPadelCabinaVentana" />
                                <span className="mapaPadelCabinaTexto">Cabina</span>
                            </div>
                        </div>

                        <div className="mapaPadelCancha">
                            {/* Líneas de la cancha */}
                            <div className="mapaPadelLineaServicioTop" />
                            <div className="mapaPadelLineaServicioBot" />
                            <div className="mapaPadelLineaCentralTop" />
                            <div className="mapaPadelLineaCentralBot" />
                            <div className="mapaPadelParedIzq" />
                            <div className="mapaPadelParedDer" />

                            {/* ID de cancha */}
                            <div className="mapaPadelCanchaId">C14</div>

                            {/* Timer */}
                            {enUso && minutosRestantes !== null && (
                                <div className="mapaPadelTimer">{minutosRestantes}&#39;</div>
                            )}

                            {/* Pelota animada */}
                            {enUso && <span className={dobles ? "mapaPadelPelota" : "mapaPadelPelotaSingles"} />}

                            {/* Jugadores */}
                            {enUso && dobles && (
                                <>
                                    <div className="mapaPadelJugador mapaPadelJugador1">
                                        {getNombreCorto(jugadores[0]) || partido.usuario || ''}
                                    </div>
                                    {jugadores[1] && (
                                        <div className="mapaPadelJugador mapaPadelJugador2">
                                            {getNombreCorto(jugadores[1])}
                                        </div>
                                    )}
                                    {jugadores[2] && (
                                        <div className="mapaPadelJugador mapaPadelJugador3">
                                            {getNombreCorto(jugadores[2])}
                                        </div>
                                    )}
                                    {jugadores[3] && (
                                        <div className="mapaPadelJugador mapaPadelJugador4">
                                            {getNombreCorto(jugadores[3])}
                                        </div>
                                    )}
                                </>
                            )}
                            {enUso && !dobles && (
                                <>
                                    {/* Singles: J0 abajo centrado (tira), J1 arriba centrado (volea) */}
                                    <div className="mapaPadelJugador mapaPadelSinglesAbajo">
                                        {getNombreCorto(jugadores[0]) || partido.usuario || ''}
                                    </div>
                                    {jugadores[1] && (
                                        <div className="mapaPadelJugador mapaPadelSinglesArriba">
                                            {getNombreCorto(jugadores[1])}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ) : (
                    renderLista()
                )}
            </Modal.Body>
        </Modal>
    );
};

export default MapaCanchasPadel;
